import React from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <div>
      <section
        className="hero-section style-two"
        style={{ backgroundImage: "url('assets/img/bg-img/1.jpg')" }}
      >
        <div className="divider"></div>

        {/* Left Side Text */}
        <div
          className="left-side-text wow fadeIn"
          data-wow-duration="1000ms"
          data-wow-delay="800ms"
        ></div>

        <div className="container">
          <div className="row g-4 g-lg-5 align-items-center">
            <div className="col-12 col-md-6">
              {/* Hero Content */}
              <div className="hero-content">
                <h2
                  className="mb-4 wow fadeInUp text-white"
                  data-wow-duration="1000ms"
                  data-wow-delay="500ms"
                >
                  Empowering Your Legal in Success
                </h2>
                <p
                  className="text-white wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  There are many variations of passages of Ipsum available, but
                  the majority suffered form randomised words injected.
                </p>
                <div className="d-flex align-items-center gap-4">
                  {/* Button */}
                  <Link
                    className="btn btn-primary wow fadeInUp"
                    to="/contactone"
                    data-wow-duration="1000ms"
                    data-wow-delay="900ms"
                  >
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              {/* Hero Thumbnail */}
              <div className="hero-thumbnail position-relative">
                <img
                  className="w-100 wow fadeInUp"
                  src="assets/img/bg-img/18.png"
                  alt=""
                  data-wow-duration="1000ms"
                  data-wow-delay="800ms"
                />

                {/* Case Solve Card */}
                <div
                  className="case-solve-card wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="1100ms"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1_740)">
                      <path
                        d="M44.6289 14.3555L40.2344 20.2148H42.6758V27.0508H46.582V20.2148H49.0234L44.6289 14.3555Z"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5.37109 14.3555L9.76562 20.2148H7.32422V27.0508H3.41797V20.2148H0.976562L5.37109 14.3555Z"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M40.4785 37.3047V31.4453H9.52148V37.3047"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M36.2051 31.4453V25.5859H13.793V31.4453"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M31.9336 25.5859V19.7266H18.0664V25.5859"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25 0.976562L27.3388 5.71543L32.5684 6.47529L28.7842 10.164L29.6775 15.3725L25 12.9133L20.3225 15.3725L21.2158 10.164L17.4316 6.47529L22.6612 5.71543L25 0.976562Z"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M36.7188 7.8125H39.6484"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.2812 7.8125H10.3516"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M35.6211 2.85928L38.2763 1.62109"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.3798 12.7656L11.7246 14.0038"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M35.6211 12.7656L38.2763 14.0038"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.3798 2.85928L11.7246 1.62109"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M20.6055 43.1641H0.976562V49.0234H49.0234V43.1641H29.3945"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M44.752 43.1641V37.3047H5.25V43.1641"
                        stroke="#D3A574"
                        strokeWidth="1.95313"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_740">
                        <rect width="50" height="50" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <div>
                    <span className="counter">400</span>+
                  </div>
                  <p className="mb-0">Successful Cases</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default HeroSection;
